import { useState, useMemo } from 'react'
import { Box, Stack } from '@mui/material'
import {
  StyledStack,
  StyledAccordion,
  StyledAccordionSummary,
  StyledTitle,
  StyledDivider,
  StyledCounter,
  StyledIconButton,
  StyledAccordionDetails,
  StyledSubRow,
  StyledSubRowStack,
  StyledSubRowContent,
  StyledSubRowText,
} from './StackSelection.styles'
import { useTreeContext } from '../../TreeProvider'

const StackSelection = ({ accounts, onRemoveAccount }) => {
  const [order] = useState('asc')
  const {canRemoveSelection} = useTreeContext()
  const sortedAccounts = useMemo(() => [...accounts].sort((a, b) => {
    if (order === 'asc') {
      return a.name.localeCompare(b.name);
    } else {
      return b.name.localeCompare(a.name);
    }
  }), [accounts]);

  return (
    <StyledStack>
      {sortedAccounts.map((account) => (
        <StyledAccordion disableGutters elevation={0} defaultExpanded key={account.sf_id}>
          <StyledAccordionSummary
            expandIcon={
              <Box sx={{ color: '#656565' }}>
                <i className="fa-solid fa-chevron-up" />
              </Box>
            }
          >
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
              <StyledTitle>{account.name}</StyledTitle>
              <Stack direction="row" alignItems="center" spacing={1}>
                <StyledDivider />
                <StyledCounter>{account.children.length}</StyledCounter>
                {
                  canRemoveSelection && (
                    <StyledIconButton onClick={() => onRemoveAccount(account)}>
                      <i className="fa-regular fa-xmark" style={{ fontSize: '9px' }} />
                    </StyledIconButton>
                  )
                }
              </Stack>
            </Box>
          </StyledAccordionSummary>
          <StyledAccordionDetails>
            {[...account.children].sort((a,b) => a.label.localeCompare(b.label)).map((subRow, index, array) => (
              <StyledSubRow>
                <StyledSubRowStack direction="row">
                  <Stack sx={{ flex: 1 }}>
                    <Box sx={{ flex: 1 }} />
                  </Stack>
                  <Stack sx={{ flex: 1 }}>
                    <Box sx={{
                      flex: 1,
                      borderLeft: 'solid 1px #EFEFEF',
                      ...(index === array.length - 1 && { borderBottomLeftRadius: '6px' })
                    }} />
                    <Box sx={{
                      flex: 1,
                      ...(index === array.length - 1
                        ? {
                          borderBottom: 'solid 1px #EFEFEF',
                          transform: 'translateY(-16px)',
                          borderBottomLeftRadius: '6px',
                        }
                        : {
                          borderLeft: 'solid 1px #EFEFEF'
                        }
                      )
                    }} />
                  </Stack>
                </StyledSubRowStack>
                <StyledSubRowContent direction="row" alignItems="center" justifyContent="space-between">
                  <StyledSubRowText italic={subRow.state === 'Etude'}>{subRow.label}</StyledSubRowText>
                  {
                    canRemoveSelection && (
                      <StyledIconButton onClick={() => onRemoveAccount(subRow)}>
                        <i className="fa-regular fa-xmark" style={{ fontSize: '9px' }} />
                      </StyledIconButton>
                    )
                  }
                </StyledSubRowContent>
              </StyledSubRow>
            ))}
          </StyledAccordionDetails>
        </StyledAccordion>
      ))}
    </StyledStack>
  )
}

export default StackSelection
